import ViewTestResult from "@/pages/sat/includes/test-result/ViewTestResult";
import { lazy } from "react";
import { Route } from "react-router-dom";

const LazySatModule = lazy(() => import("@/pages/sat"));
const LazyTestCycles = lazy(() => import("@/pages/sat/includes/test-cycles"));
const LazyTests = lazy(() => import("@/pages/sat/includes/tests"));

const SatRoutes = (
  <Route
    path="sat"
    element={<LazySatModule />}
  >
    <Route
      index
      element={<LazyTestCycles />}
    />
    <Route
      path=":test-cycle"
      element={<LazyTests />}
    />
    <Route
      path=":test-cycle/:test"
      element={<ViewTestResult />}
    />
  </Route>
);

export default SatRoutes;
